import { render, staticRenderFns } from "./LottiePlayer.vue?vue&type=template&id=4a624686&scoped=true"
import script from "./LottiePlayer.vue?vue&type=script&lang=js"
export * from "./LottiePlayer.vue?vue&type=script&lang=js"
import style0 from "./LottiePlayer.vue?vue&type=style&index=0&id=4a624686&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a624686",
  null
  
)

export default component.exports